
// @ts-nocheck
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import BoosterPicture from '../node_modules/nuxt-booster/runtime/components/BoosterPicture.vue'
import Company from '../components/blocks/Company.vue'
import Event from '../components/blocks/Event.vue'
import Opportunity from '../components/blocks/Opportunity.vue'
import News from '../components/blocks/News.vue'
import Banner from '../components/blocks/Banner.vue'
import LaunchBox from '../components/blocks/LaunchBox.vue'
import Social from '../components/blocks/Social.vue'
import Newsletter from './newsletter.vue'
import { loadPlaces as loadGooglePlaces } from '~/utils/googlePlaces'
const en = require('@/assets/images/flags/en.svg')
const it = require('@/assets/images/flags/it.svg')
const pt = require('@/assets/images/flags/pt.svg')
const es = require('@/assets/images/flags/es.svg')
const de = require('@/assets/images/flags/de.svg')
const fr = require('@/assets/images/flags/fr.svg')

export default Vue.extend({
  name: 'Home',
  components: {
    Social,
    Company,
    Event,
    Opportunity,
    News,
    Banner,
    LaunchBox,
    BoosterPicture,
    OverlayPanel: () => import('primevue/overlaypanel'),
    InputText: () => import('primevue/inputtext'),
    Button: () => import('primevue/button'),
    Newsletter
  },
  layout: 'home-footer',
  data () {
    return {
      picture: {
        sources: [
          {
            src: '/assets/homepage/mobile-banner.png',
            sizes: { default: '320px', xxs: '420px', xs: '575px' },
            media: '(min-width:0px) and (max-width: 575px)'
          },
          {
            src: '/assets/homepage/tablet-banner.png',
            sizes: { sm: '767px' },
            media: '(min-width: 576px) and (max-width: 767px)'
          },
          {
            src: '/assets/homepage/desktop-banner.png',
            sizes: { md: '996px', lg: '1200px', xl: '1367px' },
            media: '(min-width: 768px) and (max-width: 1367px)'
          },
          {
            src: '/assets/homepage/desktop-xl-banner.png',
            sizes: { xxl: '1600px', '4k': '1920px' },
            media: '(min-width: 1368px)'
          }
        ],
        title: 'Cving Banner',
        alt: 'Cving Banner'
      },
      flags: { en, it, pt, es, fr, de },
      toggleLanguageOpen: false,
      activeIndex: null,
      countPublishedCampaigns: 0,
      sectionsVisibility: [],
      launchBoxes: [],
      banners: [],
      opportunities: [],
      companies: [],
      events: [],
      news: [],
      settingsBanner: [
        {
          maxWidth: 9999,
          slidesPerPage: 1,
          peekRight: '0px',
          gutter: 6
        }
      ],
      settings: [
        {
          maxWidth: 9999,
          slidesPerPage: 5,
          peekRight: '0px',
          gutter: 0
        },
        {
          maxWidth: 1440,
          slidesPerPage: 4,
          peekRight: '0px',
          gutter: 0
        },
        {
          maxWidth: 1280,
          slidesPerPage: 3,
          peekRight: '0px',
          gutter: 0
        },
        {
          maxWidth: 991,
          slidesPerPage: 2,
          peekRight: '60px',
          peekLeft: '0px',
          gutter: 0
        },
        {
          maxWidth: 768,
          slidesPerPage: 2,
          peekRight: '36px',
          gutter: 0
        },
        {
          maxWidth: 576,
          slidesPerPage: 1,
          peekRight: '36px',
          gutter: 0
        }
      ],
      search: {
        text: '',
        city: null
      },
      filteredCities: [],
      service: null,
      servicePlaces: null,
      isLoadingPlaces: false,
      timer: null,
      $sanitizeTitle: null,
      posts: []
    }
  },
  async fetch() {
    try {
      const sectionsVisibilityRes = await this.$axios.get('/proxysbapi/home/sections-visibility', {
        timeout: 3000
      })
      this.sectionsVisibility = sectionsVisibilityRes?.data || []
    } catch (err) {
      if (this.$auth.loggedIn) {
        this.$sentry.setTag('email', this.$auth.user.email)
      }
      this.$sentry.captureException(err)
      console.log('Errore nella richiesta sections-visibility: ', err)
      this.sectionsVisibility = []
    }

    try {
      const countPublishedCampaignsRes = await this.$axios.get('/proxysbapi/home/count-published-campaigns', {
        timeout: 3000
      })
      const count = Number(countPublishedCampaignsRes?.data?.count)
      this.countPublishedCampaigns = isNaN(count) ? null : count
    } catch (err) {
      if (this.$auth.loggedIn) {
        this.$sentry.setTag('email', this.$auth.user.email)
      }
      this.$sentry.captureException(err)
      console.log('Errore nella richiesta count-published-campaigns: ', err)
      this.countPublishedCampaigns = null
    }
    if (this.isSectionVisible('LAUNCH_BOX')) {
      try {
        const launchBoxesRes = await this.$axios.get('/proxysbapi/home/launch-box', {
          timeout: 3000
        })
        this.launchBoxes = launchBoxesRes?.data || []
      } catch (err) {
        if (this.$auth.loggedIn) {
          this.$sentry.setTag('email', this.$auth.user.email)
        }
        this.$sentry.captureException(err)
        console.log('Errore nella richiesta launch-box: ', err)
        this.launchBoxes = []
      }
    }

    if (this.isSectionVisible('BANNER')) {
      try {
        const bannersRes = await this.$axios.get('/proxysbapi/home/banner', {
          timeout: 3000
        })
        this.banners = bannersRes?.data || []
      } catch (err) {
        if (this.$auth.loggedIn) {
          this.$sentry.setTag('email', this.$auth.user.email)
        }
        this.$sentry.captureException(err)
        console.log('Errore nella richiesta banner: ', err)
        this.banners = []
      }
    }
    if (this.isSectionVisible('CAMPAIGNS_OPPORTUNITIES')) {
      try {
        const opportunitiesRes = await this.$axios.get('/proxysbapi/home/campaigns-opportunities', {
          params: { lang: this.$i18n.locale },
          timeout: 3000
        })
        this.opportunities = opportunitiesRes?.data.sort((a, b) => { return new Date(b.ts).getTime() - new Date(a.ts).getTime() }) || []
      } catch (err) {
        if (this.$auth.loggedIn) {
          this.$sentry.setTag('email', this.$auth.user.email)
        }
        this.$sentry.captureException(err)
        console.log('Errore nella richiesta campaigns-opportunities: ', err)
        this.opportunities = []
      }
    }
    if (this.isSectionVisible('FEATURED_COMPANIES')) {
      try {
        const companiesRes = await this.$axios.get('/proxysbapi/home/featured-companies', {
          params: { limit: 10 },
          timeout: 3000
        })
        this.companies = companiesRes?.data || []
      } catch (err) {
        if (this.$auth.loggedIn) {
          this.$sentry.setTag('email', this.$auth.user.email)
        }
        this.$sentry.captureException(err)
        console.log('Errore nella richiesta featured-companies: ', err)
        this.companies = []
      }
    }
    if (this.isSectionVisible('EVENTS')) {
      try {
        const eventsRes = await this.$axios.get('/proxysbapi/home/events', {
          timeout: 3000
        })
        const now = new Date().getTime()
        this.events = eventsRes?.data.filter((e) => { return new Date(e.startDate).getTime() - now > 0 })
        this.events = this.events.sort((a, b) => { return new Date(a.startDate).getTime() - new Date(b.startDate).getTime() }) || []
      } catch (err) {
        if (this.$auth.loggedIn) {
          this.$sentry.setTag('email', this.$auth.user.email)
        }
        this.$sentry.captureException(err)
        console.log('Errore nella richiesta events: ', err)
        this.events = []
      }
    }
    if (this.isSectionVisible('ARTICLES')) {
      try {
        const newsRes = await this.$axios.get('/proxymedia/wp-json/wp/v2/posts', {
          params: { per_page: 10, categories_exclude: 70, _embed: true, _fields: 'title,date,link, yoast_head_json.description' },
          timeout: 3000
        })
        this.news = newsRes?.data || []
      } catch (err) {
        if (this.$auth.loggedIn) {
          this.$sentry.setTag('email', this.$auth.user.email)
        }
        this.$sentry.captureException(err)
        console.log('Errore nella richiesta news: ', err)
        this.news = []
      }
    }
    if (this.isSectionVisible('OUR_SOCIALS')) {
      const API_KEY = 'c3f94cd9-8318-4225-b857-72365d3cef82' // La tua API key
      const FEED_ID = 'bf7b52c6-fb20-487b-a06b-8a0adb4cca63' // Il tuo Feed ID
      const url = `https://api.curator.io/v1/feeds/${FEED_ID}/posts`

      try {
        const response = await this.$axios.get(url, {
          params: {
            api_key: API_KEY,
            limit: 10,
            offset: 0
          },
          timeout: 3000
        })
        if (response?.data?.posts && response?.data?.posts?.length) {
          this.posts = response.data.posts.map(post => ({
            id: post.id,
            link: post.url,
            unformat: post.text,
            message: post.text,
            created_at: post.source_created_at,
            author: post.user_full_name || post.user_screen_name,
            author_image: post.user_image,
            image: (post.image && post.image.trim() !== '' && post.image.startsWith('http')) ? post.image : null,
            source: post.network_name, // Tipo di social media (es: Facebook, Instagram, ecc.)
            likes: post.likes,
            comments: post.comments
          }))
        }
      } catch (error) {
        console.error('Errore nel recupero dei post:', error)
      }
    }
  },
  head (): any {
    const json = {
      '@context': 'http://schema.org',
      '@type': 'Corporation',
      '@id': 'https://id.cving.com',
      legalName: 'CVing S.r.l.',
      url: 'https://cving.com',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Milano',
        addressCountry: 'Italia',
        postalCode: '20144',
        streetAddress: 'Via Tortona, 33'
      },
      logo: 'https://cving.com/logo-cving.png',
      sameAs: [
        'https://www.facebook.com/CVINGapp',
        'https://www.linkedin.com/company/cving/',
        'https://www.instagram.com/cving_app/',
        'https://www.crunchbase.com/organization/cving'
      ]
    }
    return {
      script: [{ type: 'application/ld+json', json }],
      bodyAttrs: {
        class: 'homepage'
      },
      title: 'CVing',
      meta: [
        { hid: 'robots', name: 'robots', content: process.env.BUILD_ENV === 'production' ? 'index,follow' : 'noindex,nofollow' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1.0, user-scalable=yes, minimum-scale=1.0, maximum-scale=5.0' },
        { name: 'apple-mobile-web-app-capable', content: 'yes' },
        { name: 'apple-mobile-web-app-status-bar-style', content: 'black-translucent' },
        { name: 'mobile-web-app-capable', content: 'yes' },
        { name: 'theme-color', content: '#000000' },
        { hid: 'description', name: 'description', content: (this as any).$t('home.metaDescription') },
        { hid: 'og:description', name: 'og:description', content: (this as any).$t('home.metaDescription') }
      ]
    }
  },
  computed: {
    ...mapGetters({
      isExtraSmallMobile: 'site/isExtraSmallMobile',
      googleKey: 'radar/getGoogleKey'
    }),
    placeholderWhat() {
      const fullText = this.$t('home.what').toString()
      return this.isExtraSmallMobile ? fullText.split(',')[0] : fullText
    },

    placeholderCity() {
      const fullText = this.$t('home.city').toString()
      return this.isExtraSmallMobile ? fullText.split(',')[0] : fullText
    },

    getLangs():{code:string}[] {
      const langs = JSON.parse(JSON.stringify(this.$i18n.locales))
      return langs.sort((l: { code: string }, m: { code: any }) => l.code.localeCompare(m.code))
    },
    link() {
      let link = ''
      let sanitizedCity = ''
      let formattedCity = ''
      const cityName = this.search.city?.formatted_locality || ''

      if (cityName !== '') {
        sanitizedCity = this.$sanitizeTitle(cityName)
        formattedCity = cityName.charAt(0).toUpperCase() + cityName.slice(1)

        if (this.search.text !== '') {
          link = this.localePath({
            name: 'radar-city',
            params: { city: sanitizedCity },
            query: {
              search: this.$sanitizeTitle(this.search.text),
              radius: '15000',
              p: '1',
              ea: '0',
              verified: 'true',
              orp: 'false',
              order: '1'
            }
          })
        } else {
          link = this.localePath({
            name: 'radar-city',
            params: { city: formattedCity },
            query: {
              radius: '15000',
              p: '1',
              ea: '0',
              verified: 'true',
              orp: 'false',
              order: '1'
            }
          })
        }
      } else if (this.search.text !== '') {
        link = this.localePath({
          name: 'radar',
          query: {
            search: this.$sanitizeTitle(this.search.text),
            p: '1',
            ea: '0',
            verified: 'true',
            orp: 'false',
            order: '1'
          }
        })
      } else {
        link = this.localePath({
          name: 'radar',
          query: {
            p: '1',
            ea: '0',
            verified: 'true',
            orp: 'false',
            order: '1'
          }
        })
      }

      return link
    },
    items() {
      return [
        {
          class: 'pi pi-user',
          label: this.$t('home.candidates'),
          items: [
            {
              label: 'CVing.com',
              url: '/',
              class: 'cving-link',
              target: '_self'
            },
            {
              label: this.$t('footer.searchJob').toString(),
              url: this.localePath({
                name: 'radar',
                query: {
                  p: '1',
                  order: '1',
                  ea: '0',
                  verified: 'true',
                  orp: 'false'
                }
              }),
              class: 'search-job-link',
              target: '_self'
            },
            {
              label: this.$t('footer.suggestFriend').toString(),
              url: 'https://business.cving.com/openreferralprogram',
              class: 'suggest-friend-link',
              target: '_blank'
            },
            {
              label: this.$t('footer.signUp').toString(),
              url: this.localePath('/signup'),
              class: 'signup-link',
              target: '_self'
            },
            {
              label: 'News',
              url: 'https://media.cving.com/',
              class: 'news-link',
              target: '_blank'
            },
            {
              label: this.$t('footer.personalityTest').toString(),
              url: this.$auth.loggedIn
                ? this.localePath('/user/settings/personality-test')
                : this.localePath('/user/test'),
              class: 'personality-test-link',
              target: '_self'
            },
            {
              label: 'Customer support',
              url: 'https://support.cving.com/hc/it',
              class: 'customer-support-link',
              target: '_blank'
            }
          ]
        },
        {
          class: 'pi pi-briefcase',
          label: this.$t('home.companies'),
          items: [
            {
              label: this.$t('footer.discoverWhatWeCanDoForYou').toString(),
              url: 'https://business.cving.com/per-le-aziende',
              class: 'company-platform-link',
              target: '_blank'
            }
          ]
        },
        {
          class: 'pi pi-building',
          label: this.$t('home.corporate'),
          items: [
            {
              label: 'Legal info',
              url: 'https://media.cving.com/legal-info/',
              class: 'legal-info-link',
              target: '_blank'
            }
          ]
        }
      ]
    }
  },
  methods: {
    // Google Maps serve solo all'autocomplete della citta': lo scarichiamo al primo
    // focus del campo invece che al mounted(), come in pages/radar.vue.
    // Il caricamento vero e' in utils/googlePlaces.js, condiviso tra le pagine.
    loadPlaces() {
      return loadGooglePlaces(this.googleKey, this.$i18n.locale).then((places) => {
        this.service = places.service
        this.servicePlaces = places.servicePlaces
        return places
      })
    },
    ...(mapActions({
      setCity: 'radar/setCity',
      setLat: 'radar/setLat',
      setLon: 'radar/setLon',
      setSearchTitle: 'radar/setSearchTitle'
    }) as {
      setCity: (city: string) => void
      setLat: (lat: number) => void
      setLon: (lon: number) => void
      setSearchTitle: (title: string) => void
    }),
    getMedia(url) {
      if (url) {
        const parts = url.split('/')
        const updatedUrl = parts.slice(4).join('/')
        return '/' + updatedUrl
      } else {
        return ''
      }
    },
    searchCampaigns() {
      const cityName = this.search.city?.formatted_locality || ''
      if (cityName !== '') {
        const city = cityName.charAt(0).toUpperCase() + cityName.slice(1)
        this.setCity(city)
        if (this.search.city?.lat) {
          this.setLat(this.search.city.lat)
        }
        if (this.search.city?.lon) {
          this.setLon(this.search.city.lon)
        }
      }
      if (this.search.text) {
        this.setSearchTitle(this.$sanitizeTitle(this.search.text))
      }
      this.$router.push(this.localePath(this.link))
    },
    update(loc) {
      clearTimeout(this.timer)
      if (loc && loc.length > 0) {
        this.isLoadingPlaces = true
        this.timer = setTimeout(() => {
          this.loadPlaces().then(({ service }) => {
            service.getPlacePredictions(
              {
                input: loc,
                types: ['administrative_area_level_3']
              },
              this.displaySuggestions
            )
          }).catch(() => {
            this.isLoadingPlaces = false
          })
        }, 750)
      }
    },
    displaySuggestions(predictions, status) {
      if (status !== 'OK') {
        this.filteredCities = []
        this.isLoadingPlaces = false
        return
      }
      this.filteredCities = predictions
        .filter(pred => this.search?.city?.place_id !== pred.place_id)
        .map((p) => {
          if (p) {
            p.formatted_locality_complete = p?.description
            p.formatted_locality = p.structured_formatting.main_text
          }
          return p
        })
      this.isLoadingPlaces = false
    },
    addSelectedPlaces(e) {
      if (!this.servicePlaces) { return }
      this.servicePlaces.getDetails(
        {
          placeId: e.place_id,
          types: '(cities)',
          fields: ['geometry.location']
        },
        (place, serviceStatus) => {
          this.createGoogleLocations(place, serviceStatus)
        }
      )
    },
    createGoogleLocations(place, serviceStatus) {
      if (serviceStatus === 'OK' && place?.geometry?.location) {
        const location = place.geometry.location
        const formattedLocality = this.search.city?.formatted_locality || ''
        if (formattedLocality) {
          this.search.city.lat = location.lat()
          this.search.city.lon = location.lng()
        }
      }
    },
    getIframeSrc() {
      return this.$i18n.locale === 'it'
        ? 'https://cloud.news.cving.com/cvingform_ita'
        : 'https://cloud.news.cving.com/cvingform_en'
    },
    toggleMenu(index) {
      this.activeIndex = this.activeIndex === index ? null : index
    },
    isSectionVisible(sectionName: string): boolean {
      const section = this.sectionsVisibility.find((item: { sectionName: string }) => item.sectionName === sectionName)
      return section ? section.visible : true
    },
    async changeLanguage(lang: string) {
      const overlayPanel = this.$refs.op as Vue & { hide: () => void }

      // Nascondi il pannello di sovrapposizione se esiste
      if (overlayPanel?.hide) {
        overlayPanel.hide()
        this.toggleLanguageOpen = false
      }

      // Cambia la lingua di i18n e dayjs
      this.$i18n.setLocale(lang)
      this.$dayjs.locale(lang)

      // Se l'utente è loggato, aggiorna la lingua nel profilo utente
      if (this.$auth?.loggedIn) {
        let updatedUser = { ...this.$auth.user, locale: lang }
        updatedUser = JSON.parse(JSON.stringify(updatedUser))
        try {
          await this.$axios.post('/proxyapi/auth/update-user', updatedUser)
          this.$auth.setUser(updatedUser)
        } catch (error) {
          console.error('Error updating user locale:', error)
        }
      }

      // Costruisci il nuovo nome della rotta
      const name = this.$route.name.replace(/___\w+$/, '') + '___' + lang
      const newRoute = this.$router.resolve({
        name,
        params: this.$route.params,
        query: { ...this.$route.query },
        hash: this.$route.hash
      })

      // Modifica l'URL senza ricaricare la pagina
      window.history.replaceState({}, '', newRoute.href)

      // Scorri all'inizio della pagina se necessario
      const mainContainer = document.querySelector('.cving-homepage')
      if (mainContainer) {
        mainContainer.scrollTo({ top: 0 })
      }

      console.log('Language changed to:', this.$i18n.locale)
    },
    toggleLanguage(event) {
      const overlayPanel = this.$refs.op as any
      if (overlayPanel && typeof overlayPanel.toggle === 'function') {
        overlayPanel.toggle(event)
        this.toggleLanguageOpen = !this.toggleLanguageOpen
      } else {
        console.log('Il metodo toggle non esiste su questo riferimento.')
      }
    },
    openLink(link: string | URL, target: string) {
      // Controlla se è un link interno (relativo)
      const isInternal = typeof link === 'string' && link.startsWith('/')

      if (isInternal) {
        const hasLocale = link.startsWith(`/${this.$i18n.locale}/`) || this.$i18n.locale === this.$i18n.defaultLocale
        const localizedLink = hasLocale ? link : `/${this.$i18n.locale}${link}`

        if (target === '_self') {
          // Usa il router per navigazione interna
          this.$router.push(localizedLink)
          return
        }

        // Apri in nuova tab con il link localizzato
        link = localizedLink
      }

      // Link esterno o apertura in nuova tab
      const newWindow = window.open(link, target)
      if (newWindow) {
        newWindow.opener = null
        newWindow.focus()
      } else {
        alert('I popup sono bloccati dal tuo browser. Abilita i popup per aprire il link.')
      }
    }
  }
})
